module.exports = __webpack_public_path__ + "static/media/Piercing-femintimate-VHC.c111f02b.png";